@if (!isLoading) {
  <div class="main-container" data-cy="patient-portal-confirm-appointment-main-container">
    <div class="main-title" data-cy="patient-portal-confirm-appointment-main-title-text">
      Your appointment is scheduled for: <br/>
      <span data-cy="patient-portal-confirm-appointment-appointment-title-label">{{ appointment.displayTitle }}</span>
    </div>
    <div class="sub-container" data-cy="patient-portal-confirm-appointment-arrival-time-container">
      <div class="sub-title" data-cy="patient-portal-confirm-appointment-arrival-time-title-text">
        Please select your arrival time
      </div>
      <mat-form-field class="time-select" data-cy="patient-portal-confirm-appointment-arrival-time-form-field">
        <mat-select [(ngModel)]="arrivalTime" data-cy="patient-portal-confirm-appointment-arrival-time-select-input">
          @for (arriveTime of arriveTimes; track arriveTime) {
            <mat-option [value]="arriveTime" data-cy="patient-portal-confirm-appointment-arrival-time-option">
              {{ arriveTime }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="action-container" data-cy="patient-portal-confirm-appointment-action-buttons-container">
      <button mat-button class="tdo-close" color="warn" (click)="close(false)" data-cy="patient-portal-confirm-appointment-cancel-action-button">Cancel</button>
      <button mat-raised-button class="tdo-save"color="primary" (click)="confirmAppointment()" [disabled]="!arrivalTime" data-cy="patient-portal-confirm-appointment-confirm-action-button">Confirm</button>
    </div>
  </div>
}

@if (isLoading) {
  <div class="spinner-container" data-cy="patient-portal-confirm-appointment-loading-spinner-container">
    <mat-spinner data-cy="patient-portal-confirm-appointment-spinner"></mat-spinner>
  </div>
}
